'use client';

import { FullPageLoader } from '@/components/ui';

interface AuthLoadingProps {
  message?: string;
}

/**
 * Loading component shown during authentication check
 */
export function AuthLoading({ message = 'Authenticating...' }: AuthLoadingProps) {
  return <FullPageLoader message={message} />;
}
